// Context keys use "page_" / "sidebar_" prefix to distinguish them from tour keys
// (tour keys live in onboardingsList.js and may share similar names).

export const ROUTE_CONTEXT_MAP = {
  dashboard: "page_dashboard",
  "manual-grading": "page_manualGrading",
  "imports-assignments": "page_lmsImport",
  rubrics: "page_rubricsLibrary",
  workspace: "page_assignmentView",
  "workspace-essay-view": "page_essayView",
};

export const TOUR_CONTEXTS = {
  // Home / Dashboard page
  page_dashboard: {
    keys: ["homeWelcome"],
  },

  // Manual essay upload page (/manual-grading)
  page_manualGrading: {
    keys: ["startGrading"],
  },

  // LMS import page (/imports-assignments)
  // lmsImportStep2 is included so the compass button can re-launch the step-2
  // rubric/grading tour when the user is already on that step.
  page_lmsImport: {
    keys: ["lmsStartGrading", "lmsImportStep2"],
    restartEvents: ["onboarding:clicked:lmsImportStep2"],
  },

  // Standalone Rubrics page (/rubrics route)
  page_rubricsLibrary: {
    keys: ["rubricLibraryPage"],
  },

  // Individual essay feedback/grading page
  page_essayView: {
    keys: ["essayPage"],
  },

  // Assignment view (folder with essays list)
  page_assignmentView: {
    keys: ["assignmentView"],
    restartEvents: ["onboarding:mounted:assignmentView"],
  },

  // Rubric library sidebar (opened from any page via rubric select field)
  sidebar_rubricLibrary: {
    keys: ["rubricLibrary"],
    restartEvents: ["onboarding:opened:rubricLibrary"],
  },

  // Rubric Builder modal (create/edit rubric)
  sidebar_rubricBuilder: {
    keys: ["rubricBuilder"],
    restartEvents: ["onboarding:opened:rubricBuilder"],
  },

  // Create Rubric from File sidebar
  sidebar_createRubricFromFile: {
    keys: ["createRubricFromFile"],
    restartEvents: ["onboarding:mounted:createRubricFromFile"],
  },
};

/**
 * Returns "active" if any of the context's own tours are not completed, otherwise "done".
 * Only own keys are checked — children are informational and do not affect status.
 */
export const getTourContextStatus = (contextKey, clerkOnboardings = {}) => {
  const keys = TOUR_CONTEXTS[contextKey]?.keys || [];
  return keys.some((key) => !clerkOnboardings[key]) ? "active" : "done";
};
